import React from "react";
import { Button, Grid, Typography } from "@mui/material";
import "../../assets/css/icon.css";

const ModalError = ({
  onClose,
  confirm,
  title,
  descriptionOne,
  descriptionTwo,
  descriptionThree,
  copyButton,
  modalInfo,
  generalError,
}) => {
  return (
    <Grid
      container
      item
      xs={11}
      md={5}
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#fff",
        maxHeight: "100%",
        width: { xs: "90%", sm: "80%" },
      }}
    >
      <Grid
        item
        xs={12}
        sx={{
          minHeight: "60px",
          width: "100%",
          display: "flex",
          flexWrap: "nowrap",
          alignItems: "center",
          borderBottom: "1px solid #c6c6c6",
          px: "15px",
          py: 1,
          gap: 1.5,
        }}
      >
        <div className="icon-error-message" style={{ flexShrink: 0 }} />
        <Typography
          className="color-blue-dark"
          sx={{
            fontSize: { xs: "16px", sm: "18px" },
            fontWeight: 600,
            flex: 1,
            minWidth: 0,
          }}
        >
          {title}
        </Typography>
        {/* {!generalError && ( */}
        <div
          onClick={onClose}
          className="icon-modal-close"
          style={{ cursor: "pointer", flexShrink: 0 }}
        />
        {/* )} */}
      </Grid>

      <Grid item xs={12} sx={{ display: "flex", flexDirection: "column" }}>
        <Typography
          style={{
            padding: "10px 15px 0px 15px",
            marginTop: "20px",
          }}
          className="color-blue-dark"
        >
          {descriptionOne}
        </Typography>

        <Typography
          style={{
            padding: "0px 15px",
          }}
          className="color-blue-dark"
        >
          {descriptionTwo}
        </Typography>

        {descriptionThree && (
          <Typography
            style={{
              padding: "0px 15px",
            }}
            className="color-blue-dark"
          >
            {descriptionThree}
          </Typography>
        )}
      </Grid>

      <Grid container item xs={12} style={{ marginTop: "20px" }}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "20px",
          }}
        >
          {/* {!generalError && ( */}
          <Button className="button-bg-purple" onClick={confirm}>
            <Typography
              className="color-light"
              sx={{
                textTransform: "initial",
                fontSize: { xs: "16px", sm: "18px" },
                fontWeight: 500,
              }}
            >
              {" "}
              {copyButton}
            </Typography>
          </Button>
          {/* )} */}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ModalError;
